/**
 * Free Gift with Subscription - Dawn Theme
 * ==========================================
 * Shows a variant-picker popup for a free True Love Treats (142g) when a customer
 * adds the 600g Calming or 600g Hip & Joint product to cart WITH a subscription plan.
 * Does nothing for one-time purchases.
 *
 * SETUP INSTRUCTIONS
 * ------------------
 * 1. In Shopify Admin → Online Store → Themes → your Dawn theme → Edit code
 * 2. Under Assets, open "free-gift-subscription.js" and replace with this file.
 * 3. The script tag in theme.liquid is already in place — no changes needed there.
 */

(function () {
  'use strict';

  /* =========================================================
     CONFIG
     ========================================================= */
  const GIFT_PRODUCT_HANDLE = 'true-love';

  const TRIGGER_PRODUCT_IDS = [
    8494060241201, // 600g Calming
    8834570977585, // 600g Hip & Joint
  ];
  /* =========================================================
     END CONFIG
     ========================================================= */

  let giftProduct = null;

  // ── Fetch gift product data once on page load ──────────────────────────────
  async function fetchGiftProduct() {
    try {
      const res = await fetch(`/products/${GIFT_PRODUCT_HANDLE}.js`);
      if (!res.ok) {
        console.warn('[FreeGift] Could not fetch gift product. Check GIFT_PRODUCT_HANDLE.');
        return;
      }
      giftProduct = await res.json();
    } catch (e) {
      console.warn('[FreeGift] Error fetching gift product:', e);
    }
  }

  // ── Intercept add-to-cart form submissions ─────────────────────────────────
  function attachFormListeners() {
    document.addEventListener('submit', handleFormSubmit, true);
  }

  function handleFormSubmit(e) {
    const form = e.target;
    if (!form || form.getAttribute('action') !== '/cart/add') return;

    const sellingPlanInput = form.querySelector('[name="selling_plan"]');
    const isSubscription = sellingPlanInput && sellingPlanInput.value && sellingPlanInput.value !== '';
    if (!isSubscription) return;

    const productId = getProductIdFromForm(form);
    if (!productId || !TRIGGER_PRODUCT_IDS.includes(Number(productId))) return;

    if (!giftProduct) return;

    // Intercept the submit — we'll add the main product ourselves via fetch
    // first, then show the gift popup, then trigger Dawn's cart drawer.
    e.preventDefault();
    e.stopImmediatePropagation();

    handleSubscriptionAdd(form);
  }

  function getProductIdFromForm(form) {
    if (form.dataset.productId) return form.dataset.productId;
    const input = form.querySelector('[name="product-id"]');
    if (input) return input.value;
    const wrapper = form.closest('[data-product-id]');
    if (wrapper) return wrapper.dataset.productId;
    return null;
  }

  // ── Handle subscription ATC: add product, show popup, then open drawer ───────
  async function handleSubscriptionAdd(form) {
    // 1. Add the main subscription product via fetch (silently, no drawer yet)
    const formData = new FormData(form);
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
      if (!res.ok) {
        // If add failed, fall back to normal submit so Dawn can handle the error
        form.submit();
        return;
      }
    } catch (e) {
      form.submit();
      return;
    }

    // 2. Show the gift popup. Pass a callback for when it resolves (either
    //    gift added or declined) — that's when we open Dawn's cart drawer.
    showGiftPopup(function onResolved() {
      openDawnCartDrawer();
    });
  }

  // ── Popup ──────────────────────────────────────────────────────────────────
  function showGiftPopup(onResolved) {
    const existing = document.getElementById('fg-popup-overlay');
    if (existing) existing.remove();

    const overlay = document.createElement('div');
    overlay.id = 'fg-popup-overlay';
    overlay.innerHTML = buildPopupHTML();
    document.body.appendChild(overlay);

    const select = overlay.querySelector('#fg-variant-select');
    giftProduct.variants.forEach((v) => {
      const opt = document.createElement('option');
      opt.value = v.id;
      opt.textContent = v.title;
      if (!v.available) {
        opt.textContent += ' (Out of stock)';
        opt.disabled = true;
      }
      select.appendChild(opt);
    });

    function dismiss() {
      overlay.remove();
      if (typeof onResolved === 'function') onResolved();
    }

    overlay.querySelector('#fg-close-btn').addEventListener('click', dismiss);

    overlay.querySelector('#fg-no-thanks').addEventListener('click', (e) => {
      e.preventDefault();
      dismiss();
    });

    overlay.querySelector('#fg-add-btn').addEventListener('click', async () => {
      const selectedVariantId = Number(select.value);
      const btn = overlay.querySelector('#fg-add-btn');
      btn.textContent = 'Adding…';
      btn.disabled = true;

      await addGiftToCart(selectedVariantId);
      dismiss();
    });

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) dismiss();
    });
  }

  function buildPopupHTML() {
    return `
      <div id="fg-popup" role="dialog" aria-modal="true" aria-labelledby="fg-popup-title">
        <button id="fg-close-btn" aria-label="Close">✕</button>
        <div id="fg-popup-icon">🎁</div>
        <h2 id="fg-popup-title">You've earned a free gift!</h2>
        <p>Choose your True Love Treats (142g) flavour — on us.</p>
        <select id="fg-variant-select" aria-label="Choose a flavour"></select>
        <button id="fg-add-btn">Add free gift to cart</button>
        <a href="#" id="fg-no-thanks">No thanks</a>
      </div>
      <style>
        #fg-popup-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.55);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 99999;
          font-family: inherit;
        }
        #fg-popup {
          background: #fff;
          border-radius: 12px;
          padding: 2rem 2rem 1.5rem;
          max-width: 380px;
          width: calc(100% - 2rem);
          text-align: center;
          position: relative;
          box-shadow: 0 8px 32px rgba(0,0,0,0.18);
        }
        #fg-close-btn {
          position: absolute;
          top: 0.75rem;
          right: 0.75rem;
          background: none;
          border: none;
          font-size: 1.1rem;
          cursor: pointer;
          color: #666;
          line-height: 1;
        }
        #fg-popup-icon { font-size: 2.5rem; margin-bottom: 0.5rem; }
        #fg-popup-title {
          font-size: 1.3rem;
          font-weight: 700;
          margin: 0 0 0.4rem;
          color: #111;
        }
        #fg-popup p {
          color: #555;
          margin: 0 0 1.2rem;
          font-size: 0.95rem;
        }
        #fg-variant-select {
          width: 100%;
          padding: 0.6rem 0.8rem;
          border: 1px solid #ccc;
          border-radius: 6px;
          font-size: 1rem;
          margin-bottom: 1rem;
          cursor: pointer;
        }
        #fg-add-btn {
          display: block;
          width: 100%;
          padding: 0.75rem;
          background: #111;
          color: #fff;
          border: none;
          border-radius: 6px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          margin-bottom: 0.75rem;
          transition: background 0.2s;
        }
        #fg-add-btn:hover { background: #333; }
        #fg-add-btn:disabled { background: #666; cursor: not-allowed; }
        #fg-no-thanks {
          display: block;
          font-size: 0.85rem;
          color: #888;
          text-decoration: underline;
        }
      </style>
    `;
  }

  // ── Add gift to cart silently ──────────────────────────────────────────────
  async function addGiftToCart(variantId) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1,
            properties: {
              _gift: 'true',
              _gift_promo: 'subscription_free_gift',
            },
          }],
        }),
      });

      if (!res.ok) {
        console.warn('[FreeGift] Could not add gift to cart.');
      }
    } catch (e) {
      console.warn('[FreeGift] Error adding gift:', e);
    }
  }

  // ── Open Dawn's cart drawer after everything is added ──────────────────────
  // Rather than fighting Dawn's internals, we trigger a native form submit on
  // a hidden dummy form — but actually the simplest reliable method is to
  // click Dawn's own cart icon, which opens the drawer and fetches fresh state.
  function openDawnCartDrawer() {
    // Try to open via Dawn's cart drawer custom element open() method first
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return;
    }

    // Fallback: click the cart icon link — Dawn will open the drawer naturally
    const cartIcon = document.querySelector('#cart-icon-bubble, a[href="/cart"]');
    if (cartIcon) {
      cartIcon.click();
      return;
    }

    // Final fallback: reload so at least the count updates
    window.location.reload();
  }

  // ── Boot ──────────────────────────────────────────────────────────────────
  async function init() {
    await fetchGiftProduct();
    attachFormListeners();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ── ATC button price fix (Dawn + Seal on page load) ───────────────────────
// Problem: Seal rewrites the ATC button text with the one-time price first,
// then our script needs to correct it to the subscription price.
// Fix: add fg-atc-loading to .product-form immediately (CSS in
// section-main-product.css hides the button), then reveal once Seal has
// loaded and we've fired the price-correction event.
// NOTE: No style injection here — CSS lives in section-main-product.css.
(function () {
  if (!document.querySelector('form[action="/cart/add"]')) return;

  const LOADING_CLASS = 'fg-atc-loading';

  // Target the .product-form wrapper — confirmed via console as the right el
  function getProductForm() {
    return document.querySelector('.product-form');
  }

  // Hide the button as soon as the DOM is ready
  function hideButton() {
    const form = getProductForm();
    if (form) form.classList.add(LOADING_CLASS);
  }

  function revealButton() {
    const form = getProductForm();
    if (form) form.classList.remove(LOADING_CLASS);
  }

  // Hide immediately
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideButton);
  } else {
    hideButton();
  }

  document.addEventListener('sealsubs:subscription_widget_created', function () {
    setTimeout(function () {
      const sellingPlanInput = document.querySelector('[name="selling_plan"]');
      if (sellingPlanInput && sellingPlanInput.value) {
        sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
        sellingPlanInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
      setTimeout(revealButton, 150);
    }, 150);
  });

  // Safety net: reveal after 5s no matter what
  setTimeout(revealButton, 5000);
})();